<div class="pdf-page__footer-body">
    <div class="pdf-page__footer-content">
        <ng-content></ng-content>
    </div>
</div>
